import { createTranslateLoader } from '../../shared/utilities/createTranslateLoader';
var ɵ0 = createTranslateLoader;
var GridLayoutItemModuleDouble = /** @class */ (function () {
    function GridLayoutItemModuleDouble() {
    }
    return GridLayoutItemModuleDouble;
}());
export { GridLayoutItemModuleDouble };
export { ɵ0 };
